import { Permission } from '@/api';
import simulationEmptyState from '@/assets/simulation-empty-state.svg';
import PermissionWrapper from '@/components/auth/permission-wrapper';
import { ResponsiveEmptyStateIllustration } from '@/components/responsive-empty-state-illustration';
import { Button } from '@lego/klik-ui';
import { ControlPlusSolid } from '@lego/klik-ui/icons';
import type { ReactElement, RefObject } from 'react';

export const EmptyListAction = ({
  newSimulationTriggerRef,
  onNewSimulationClick,
}: {
  newSimulationTriggerRef: RefObject<HTMLButtonElement | null>;
  onNewSimulationClick: () => void;
}): ReactElement => {
  return (
    <div
      style={{
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: 0,
        height: 'calc(100dvh - 128px)',
        justifyContent: 'center',
        minHeight: '240px',
        padding: '16px',
        width: '100%',
      }}
    >
      <ResponsiveEmptyStateIllustration
        src={simulationEmptyState}
        alt="Simulations empty state"
        maxWidth={1495}
        height="auto"
        maxHeight="calc(100dvh - 200px)"
      />
      <PermissionWrapper requiredPermissions={[Permission.WriteSimulations]}>
        <Button
          onClick={onNewSimulationClick}
          ref={newSimulationTriggerRef}
          type="button"
          leftIcon={<ControlPlusSolid />}
        >
          Create new simulation
        </Button>
      </PermissionWrapper>
    </div>
  );
};
